module.exports = __webpack_public_path__ + "static/trello-6ca16e797bdf7c358bdcf0c6287fe1f5.svg";